import { memo, useState, useCallback } from 'react';
import Cropper, { Area, Point } from 'react-easy-crop';

const CropContainer = memo(
  function CropContainer(props: {
    image: string;
    onCropComplete?: (croppedArea: Area, croppedAreaPixels: Area) => void;
  }) {
    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const onCropComplete = useCallback(
      (croppedArea: Area, croppedAreaPixels: Area) => {
        props.onCropComplete?.(croppedArea, croppedAreaPixels);
      },
      [props],
    );

    return (
      <div className='d-flex flex-column align-items-center mb-4'>
        <Cropper
          {...props}
          crop={crop}
          zoom={zoom}
          aspect={4 / 4}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          zoomWithScroll={false}
          cropShape={'round'}
          style={{
            containerStyle: {
              position: 'relative',
              width: '100%',
              height: '350px',
              marginBottom: '16px',
              borderRadius: '8px',
            },
          }}
        />
        <input
          type='range'
          className='form-range w-75 mx-auto'
          value={zoom}
          min={1}
          max={3}
          step={0.2}
          aria-labelledby='Zoom'
          onChange={(e) => setZoom(Number(e.target.value))}
        />
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.image !== nextProps.image,
);

export default CropContainer;
